module.exports = {
  home:                         'Übersicht',
  channels:                     'Channels',
  lastChannelUpdates:           'Letzte Aktualisierungen',
  topics:                       'Themen',
  noTitle:                      'Kein Titel',
  noDescription:                'Keine Beschreibung',
  imageMap:                     'Bildermappe',
  de:                           'deutsch',
  en:                           'english',
  contact:                      'Kontakt',
  imprint:                      'Impressum',
  legal:                        'Legal',
  downloads:                    'Download',
  downloadTitle:                'Video herunterladen:',
  // downloadDescription:          '',
  directLinks:                  'Link',
  directLinkTitle:              'Video Link',
  // directLinkDescription:        '',
  shortlink:                    'Shortlink',
  //
  browseCategories:             'Kategorie wählen',
  //
  prepareDownload:              'Download wird vorbereitet...',
  //
  contactPerson:                'Ansprechpartner',
  contactCompany:               'Unternehmen',
  contactOccupation:            'Position',
  contactPhone:                 'Telefon',
  contactEmail:                 'E-mail',
  mediahubTechError:            'Bei Aufruf dieser Seite ist ein technisches Problem aufgetreten. Bitte nehmen Sie Kontakt mit der Versender des Links auf.',
  mediahubNotYetAvailable:      'Diese Seite ist noch nicht verfügbar. Bitte besuchen Sie uns wieder ab dem ',
  mediahubNoLongerAvailable:    'Diese Seite ist nicht mehr verfügbar seit dem ',
  mediahubMaxDownloads:         'Die maximale Anzahl von Aufrufen für diese Seite ist überschritten.',
  // zoomTurnedOff:                '',
  // zoomTurnedOn:                 '',
  //additional information
  additionalMedia:              'Weitere Downloads',
  additionalMediaContainer:     'Weitere Videos zu',
  moreVideos:                   'Weitere Videos',
  start:                        'Veröffentlichung von:',
  end:                          'bis:',
  //authentication
  authenticationRequired:       'Authentifizierung ist erforderlich.',
  authUsername:                 'Username',
  authPassword:                 'Passwort',
  authLogin:                    'Login',
  authWrong:                    'Username oder Passwort sind nicht korrekt. Bitte versuchen Sie es erneut.',
  //videorelated
  videoSize:                    'Auflösung',
  fileSize:                     'Dateigröße',
  formatDownloads:              'Downloadformate',
  download:                     'Download',
  mediaNotAvailable:            'Video ist für Download nicht verfügbar.',
  // QualityOfVideo
  hd:                           'HD',
  timeout:                      'Die Gültigkeit der Seite ist abgelaufen.',
  timeoutDescription:           'Aus Sicherheitsgründen sind alle Seiten nur für eine begrenzte Zeit gültig. Bitte nutzen Sie die RELOAD-Funktion Ihres Browsers um diese Seite erneut zu laden.',
  noDataForMediaHub:            'Keine Medien gefunden',
  noDataForMediaHubDescription: 'Mit diesem MediaHub sind keine Medien verknüpft.',
  mediahub:                     'MediaHub',
  loading:                      '...loading',
  //media
  title:                        'Titel',
  description:                  'Beschreibung',
  videoDescription:             'Videobeschreibung',
  mediaDescription:             'Beschreibung',
  // search
  search:                       'Suche',
  searchResults:                'Ergebnisse',
  // Player Overlay
  playerOverlayViews:           'Aufrufe:',
  playerOverlayDate:            'Datum:',
  playerOverlayTags:            'Tags:',
  // Breadcrumb
  breadcrumbYouAreHere:         'Sie sind hier:',
  breadCrumbHomepage:           'Startseite',
  breadCrumbSlider:             'Im Slider',
  // Errors
  unauthorized:                 'Fehler 401 - Nicht Authorisiert',
  forbidden:                    'Fehler 403 - Zugang verboten',
  notFound:                     'Fehler 404 - Seite nicht gefunden',
  serverError:                  'Fehler 500 - Interner Server Fehler',
  error404p1:                   'Die von Ihnen angeforderte Seite wurde nicht gefunden.',
  error404p2:                   'Bitte prüfen Sie die eingegebene Adresse.',
  error404p3:                   'Für weitere Informationen kontaktieren Sie uns ',
  error404contact:              'hier',
  //empty
  emptyString:                  ' ',
  backToOverview:               'Zurück zur Übersicht',
  showAll:                      'Alle anzeigen',
  showMore:                     'Mehr Videos zeigen',
  all:                          'Alle',
  filter_countEmbeds:           'Meistgesehene Videos',
  filter_createdAt:             'Neueste Videos',
  filter_meta_productionDate:   'Neueste Videos',
  filter_publishedDate:         'Neueste Videos',
  noCreationDate:               'Kein Erstellungsdatum',
  video:                        'Videos',
  watchVideo:                  'Video ansehen',
  sharePost:                    'Teilen Sie diesen Beitrag',
};
